import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    placeholderClass: { type: String, default: "is-placeholder" },
  };

  connect() {
    this.update();
  }

  update() {
    this.element.classList.toggle(this.placeholderClassValue, this.element.value === "");
  }
}
